var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Predicted coding'),expression:"'Predicted coding'"}],staticClass:"predicted-coding-icon",attrs:{"aria-label":"Predicted coding"}},[_c('svg',{attrs:{"viewBox":"0 0 16 16","focusable":"false","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M9.1 0.7L2.7 8.5h4.5l-0.3 6.8 6.4-8.6H8.8L9.1 0.7z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f762871","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_modules/Programs/Card-transactions/PredictedCodingIcon.vue
// module id = rd3P
// module chunks = 12